import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function BillingSuccessPage() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking"); // checking | success | error | timeout

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setState("error");
      return;
    }

    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      if (attempts > 8) {
        setState("timeout");
        return;
      }
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (data.payment_status === "paid") {
          await refresh();
          setState("success");
          setTimeout(() => navigate("/"), 2000);
          return;
        }
        if (data.status === "expired") {
          setState("error");
          return;
        }
      } catch (error) {
        console.error("Billing status poll failed:", error);
      }
      setTimeout(poll, 2000);
    };
    poll();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090b] p-8">
      <div className="bg-[#18181b] border border-[#27272a] p-10 max-w-md w-full text-center" data-testid="billing-success">
        {state === "checking" && (
          <>
            <Loader2 className="w-10 h-10 text-[#c8aa6e] spin mx-auto" />
            <h2 className="font-head text-xl text-[#fafafa] mt-5">A confirmar o pagamento…</h2>
            <p className="text-sm text-[#71717a] mt-2">Um momento, estamos a ativar o teu acesso.</p>
          </>
        )}
        {state === "success" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-[#10b981] mx-auto" />
            <h2 className="font-head text-2xl text-[#fafafa] mt-5">Pagamento confirmado!</h2>
            <p className="text-sm text-[#a1a1aa] mt-2">Acesso ativado. A redirecionar para o painel…</p>
          </>
        )}
        {(state === "error" || state === "timeout") && (
          <>
            <XCircle className="w-12 h-12 text-[#ef4444] mx-auto" />
            <h2 className="font-head text-xl text-[#fafafa] mt-5">
              {state === "timeout" ? "A processar…" : "Algo correu mal"}
            </h2>
            <p className="text-sm text-[#a1a1aa] mt-2">
              {state === "timeout"
                ? "O pagamento pode demorar a confirmar. Verifica o painel em instantes."
                : "Não foi possível confirmar o pagamento."}
            </p>
            <button onClick={() => navigate("/pricing")} className="mt-6 border border-[#3f3f46] text-[#fafafa] hover:border-[#c8aa6e] px-4 py-2 text-sm transition-colors">
              Voltar aos planos
            </button>
          </>
        )}
      </div>
    </div>
  );
}
